// @ts-strict
import {Typography} from '@ezcater/tapas';

type SupportMessageNoticeProps = {
  title: string;
  body: string;
  testId: string;
};

const SupportMessageNotice = ({
  title,
  body,
  testId,
}: SupportMessageNoticeProps): React.ReactElement => (
  <main
    className="mx-auto flex min-h-dvh w-full max-w-[640px] flex-col justify-center gap-4 bg-white px-4 py-6 text-center text-peppercorn-800"
    data-testid={testId}
  >
    <Typography render={<h1>{title}</h1>} variant="heading-lg" />
    <Typography variant="body-md">{body}</Typography>
  </main>
);

export default SupportMessageNotice;
